const autoNgTemplateLoaderTemplate1 = require('./addProfile.html');

import angular from 'angular';

import controller from './addProfileController';

angular.module('shbdeployer.app').component('addProfileView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
});
